<template>
  <div class="social-block">
    <TogglerTheme class="social-block__theme">
      <UiText
        class="footer-info__theme-text"
        font="body-caption"
        color="typography-title02"
        text="Тема:"
      />
    </TogglerTheme>
    <div class="social-block__wrapper">
      <UiText
        class="footer-info__theme-text"
        font="body-caption"
        color="typography-title02"
        :text="`${$tc('burgerMenu.socials')}:`"
      />
      <div class="social-block__list">
        <a
          v-for="item in socialList"
          :key="item.icon"
          :href="item.href"
          target="_blank"
          class="social-block__link"
        >
          <SvgIcon class="social-block__icon" :name="item.icon" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import TogglerTheme from '@/components/Base/TogglerTheme'
import { facebook, instagram, telegram, viber } from '~/util/defaultInfo'

export default {
  name: 'SocialBlock',
  components: {
    TogglerTheme,
  },
  computed: {
    socialList() {
      return [
        { href: facebook, icon: 'navigation/facebook' },
        { href: instagram, icon: 'navigation/instagram' },
        { href: telegram, icon: 'navigation/telegram' },
        { href: viber, icon: 'navigation/viber' },
      ]
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
